import { z } from "zod";

export const patchPartnershipStateSchema = z.object({
	state: z.enum(["active", "inactive"]),
});

export type PatchPartnershipStateSchema = z.infer<typeof patchPartnershipStateSchema>;
